import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';
import { selectors as rootSelectors } from '../root';

import Table from './components/table/main';
import Filters from '../shared/filters/main';
import Calendar from '../shared/calendar/main';
import UpdateApprovalCommentForm from './components/forms/update-comment';

const Main = renderViewsState(
	props => (
		<Animate>
			<div className="container__content conversions-garant-approve-requests">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<h1 className="title">{props.intl('Conversions garant approve requests')}</h1>
					</div>
				</div>
				<div className="container__content-body">
					<div className="clearfix position-relative">
						<Filters {...props} {...props.filters} />
					</div>
					<div className="display-flex justify-content-flex-end">
						<div className="ui-control-bar__item-position">
							<Calendar
								{...props.calendarOfCreationDate}
								onInit={props.calendarOfCreationDateInit}
								onToggle={props.calendarOfCreationDateToggle}
								onChange={props.calendarOfCreationDateChange}
								onApply={props.calendarOfCreationDateApply}
								intl={props.intl}
							/>
						</div>
						<div>
							<button
								className="ui-btn ui-btn-primary save margin-left-5"
								onClick={props.fetchData}
							>
								{props.intl('Apply')}
							</button>
						</div>
					</div>

					<Table {...props} />
					<UpdateApprovalCommentForm {...props} initialValues={props.commentFormInitialData} />
				</div>
			</div>
		</Animate>
	),
	'view'
);

export default connect(
	state => ({
		data: selectors.getData(state),
		commentFormInitialData: selectors.getCommentFormInitialData(state),
		table: selectors.getTable(state),
		isCommentPopupVisible: selectors.getIsCommentPopupVisible(state),
		calendarOfCreationDate: selectors.getCalendarOfCreationDate(state),
		manualApproveInitialValues: selectors.getManualApproveInitialValues(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		progressBar: selectors.getProgressBar(state),
		intl: selectors.getIntl(state),
		reasons: selectors.getReasons(state),
		filters: selectors.getFilters(state),
		can: selectors.getCan(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/conversions-garant-approve-requests/main.js